




















import { Vue, Component, Prop } from 'vue-property-decorator';

@Component
export default class Spinner extends Vue {
    /**
     *
     */
    @Prop({ default: 32 })
    public readonly size!: number;
    /**
     *
     */
    @Prop({ default: 4 })
    public readonly strokeWidth!: number;
}
